<ng-container *ngIf="tabindex">
  <button
    [tabindex]="tabindex"
    #button
    [attr.id]="id ? id : null"
    [class]="color + ' btn ' + css"
    type="button"
    (click)="click($event)"
    [disabled]="disabled"
    [ngClass]="{ disabled: disabled }"
  >
    {{ text }}
    <ng-content></ng-content>
  </button>
</ng-container>

<ng-container *ngIf="!tabindex">
  <button
    #button
    [attr.id]="id ? id : null"
    [class]="color + ' btn ' + css"
    type="button"
    (click)="click($event)"
    [disabled]="disabled"
    [ngClass]="{ disabled: disabled }"
  >
    {{ text }}
    <ng-content></ng-content>
  </button>
</ng-container>
